import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  BANK_ACCOUNT_NUMBER: `${cleanedFilename(__filename)}-bank-account-number`,
  UPDATE_TRIGGER: `${cleanedFilename(__filename)}-update-trigger`,
};
